// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cbc16637","453":"6e579afa"}[chunkId] + ".chunk.js";
};